import { SentenceWithLink } from "./types"

export const getSentenceWithLinkPieces = (sentence: SentenceWithLink) => {
  const pieces = sentence.text.split(sentence.linkText)
  const [sentenceWithLinkPartOne, sentenceWithLinkPartTwo] = pieces || []
  return [sentenceWithLinkPartOne, sentence.linkText, sentenceWithLinkPartTwo]
}

